import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["input", "tagTemplate", "includeKeywords", "excludeKeywords"]
  }

  connect() {
    Array.from(this.includeKeywordsTarget.options).forEach((option) => {
      if (option.selected) {
        this._appendTagToElementChildren(option.value)
      }
    })

    Array.from(this.excludeKeywordsTarget.options).forEach((option) => {
      if (option.selected) {
        this._appendTagToElementChildren(option.value, false)
      }
    })
  }

  addTag(event) {
    event.preventDefault()
    let value = this.inputTarget.value
    let sanitizedValue = value.replace(/[^\p{L}0-9.]/gu, " ")
    if (sanitizedValue.trim() === "") {
      return
    }

    this._appendTagToElementChildren(sanitizedValue)
    this._addTagToSelect(sanitizedValue, true)
    this._dispatchChangeEvent()
    this.inputTarget.value = ""
  }

  changeTag({ detail: { tagValue, included } }) {
    this.tagRemoved({ detail: { tagValue, included: !included } })
    this._addTagToSelect(tagValue, included)
    this._dispatchChangeEvent()
  }

  tagRemoved({ detail: { tagValue, included } }) {
    let index = 0
    let selectElement = included ? this.includeKeywordsTarget : this.excludeKeywordsTarget
    for (let i = 0; i < selectElement.options.length; i++) {
      if (selectElement.options[i].value === tagValue) {
        index = i
        break
      }
    }
    selectElement.options.remove(index)
    this._dispatchChangeEvent()
  }

  _addTagToSelect(value, included) {
    let option = new Option(value, value, true, true)
    let selectElement = included ? this.includeKeywordsTarget : this.excludeKeywordsTarget
    selectElement.options.add(option)
  }

  _appendTagToElementChildren(value, included = true) {
    let tagHtml = this.tagTemplateTarget.innerHTML
    tagHtml = tagHtml.replace(/%LABEL%/g, value)
    tagHtml = tagHtml.replace(/%VALUE%/g, value)
    tagHtml = tagHtml.replace(/%INCLUDED%/g, included)
    let tagNode = document.createElement("div")
    tagNode.innerHTML = tagHtml
    this.element.appendChild(tagNode.firstElementChild)
  }

  _dispatchChangeEvent() {
    this.dispatch("change", {})
  }
}
